module.exports = __webpack_public_path__ + "img/bogoboyashy.1c12c479.png";